import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

/**
 * Client portal branding and visibility flags. The payload selects the
 * client node rather than the config type: the config type carries no id,
 * so a config-only payload lands in a record nothing references and the
 * surface re-hydrates from the pre-save value until an unrelated refetch
 * replaces it.
 */
const mutation = graphql`
	mutation updateClientPortalConfigMutation($input: UpdateClientPortalConfigInput!) {
		updateClientPortalConfig(input: $input) {
			client {
				id
				portalConfig {
					portalActive
					portalLogoUrl
					portalPrimaryColour
					portalSenderName
					showInvoices
					allowFileUpload
					showRetainer
					showComments
					hideTimeEntries
					hideEstimates
				}
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return trackAndCommitMutation(environment, {mutation, variables, onCompleted: onSuccess, onError}, true);
}

export default {commit};
